<template>
  <el-transfer
    filterable
    ref="transfer"
    filter-placeholder="请输入关键字"
    :titles="titles"
    v-model="value"
    :data="data"
    @change="change"
  >
  </el-transfer>
</template>

<script>
import eventBus from "@/utils/eventBus.js";
export default {
  created() {
    eventBus.$on("transfer-Reset", this.reset);
  },
  destroyed() {
    eventBus.$off("transfer-Reset", this.reset);
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    titles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    change() {
      eventBus.$emit("transfer-Change", this.value);
    },
    reset() {
      this.$refs.transfer.clearQuery("left");
      this.$refs.transfer.clearQuery("right");
      this.value = [];
    },
  },
};
</script>

<style></style>
